import { render } from "./BioCard.vue?vue&type=template&id=33ba2743"
import script from "./BioCard.vue?vue&type=script&lang=js"
export * from "./BioCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__